import { useEffect, useState } from "react";
import { ArrowRight, HelpCircle, Check, X } from "lucide-react";
import { Avatar, vibrate } from "../ui";

export default function Result({ game, onContinue, onGuess, play }) {
  const out = game.out;
  const [flipped, setFlipped] = useState(false);
  const [guessing, setGuessing] = useState(false);

  useEffect(() => {
    if (!out) return;
    const t = setTimeout(() => {
      setFlipped(true);
      vibrate(out.role === "impostor" ? [60, 40, 60, 40, 200] : 150);
      play(out.role === "impostor" ? "win" : "eliminate");
    }, 900);
    return () => clearTimeout(t);
  }, [out]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!out) {
    return (
      <div className="screen center">
        <div className="glass section result-none" data-testid="no-elimination">
          <h1 className="screen-title">Nadie fue eliminado</h1>
          <p className="muted">El impostor sigue entre ustedes…</p>
        </div>
        <div className="actions">
          <button className="btn btn-primary btn-xl full" onClick={onContinue} data-testid="continue-btn">Continuar <ArrowRight size={22} /></button>
        </div>
      </div>
    );
  }

  const imp = out.role === "impostor";

  if (guessing) {
    return (
      <div className="screen center">
        <div className="glass section guess" data-testid="guess-panel">
          <HelpCircle size={40} className="accent" />
          <h1 className="screen-title">{out.name} intenta adivinar</h1>
          <p className="muted">Que diga en voz alta la palabra secreta. ¿Acertó?</p>
        </div>
        <div className="actions row">
          <button className="btn btn-danger btn-xl grow" onClick={() => onGuess(true)} data-testid="guess-correct-btn"><Check size={22} /> Acertó</button>
          <button className="btn btn-safe btn-xl grow" onClick={() => onGuess(false)} data-testid="guess-wrong-btn"><X size={22} /> Falló</button>
        </div>
      </div>
    );
  }

  return (
    <div className="screen center">
      <p className="muted">El grupo eliminó a</p>
      <div className={`flip${flipped ? " flipped" : ""}`} data-testid="elimination-card">
        <div className="flip-inner">
          <div className="flip-face glass">
            <Avatar name={out.name} size="xl" />
            <span className="flip-name">{out.name}</span>
            <span className="muted">¿Quién era en realidad?</span>
          </div>
          <div className={`flip-face flip-back glass role-${out.role}`}>
            <Avatar name={out.name} size="xl" dead />
            <span className="flip-name struck">{out.name}</span>
            <span className="role-tag" data-testid="eliminated-role">{imp ? "ERA IMPOSTOR" : "ERA INOCENTE"}</span>
          </div>
        </div>
      </div>
      {flipped && (
        <div className="actions pop-in">
          {imp && (
            <button className="btn btn-ghost full" onClick={() => setGuessing(true)} data-testid="impostor-guess-btn">
              <HelpCircle size={18} /> El impostor intenta adivinar la palabra
            </button>
          )}
          <button className="btn btn-primary btn-xl full" onClick={onContinue} data-testid="continue-btn">Continuar <ArrowRight size={22} /></button>
        </div>
      )}
    </div>
  );
}
